import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { range } from 'lodash-es';
import { SOURCES } from 'client/utils/image-helpers';
import { Image } from 'site-modules/shared/components/image/image';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { Collapse } from 'site-modules/shared/components/collapse/collapse';

import './dealer-five-star-awards.scss';

function getYearsRange(years) {
  const minYear = Math.min(...years);
  const maxYear = Math.max(...years);
  const rangeOfYears = range(minYear, maxYear);
  const allYearsIncluded = rangeOfYears.every(year => years.includes(year));

  return allYearsIncluded ? `${minYear}-${maxYear}` : `${minYear} + ${years.length - 1} more`;
}

export function DealerFiveStarAwards({ years }) {
  const [isOpen, toggleOpen] = useToggle(false);

  if (!years.length) return null;

  const isSingleYear = years.length === 1;

  return (
    <div className="dealer-five-star-awards-wrapper w-100 pos-r">
      <div
        className={classNames('dealer-five-star-awards rounded-16 pos-a mx-auto left-0 right-0', { expanded: isOpen })}
      >
        <div className="dealer-five-star-awards-content pos-r p-1 rounded-16">
          <div className="d-flex align-items-center">
            <div className="dealer-five-star-awards-logo pe-1_5">
              <Image
                imageId="/img/dealer-thanks/5star-dealer-side-white.png"
                source={SOURCES.STATIC}
                alt="5 star award"
                width={87}
                height={32}
                lazy
              />
            </div>
            <div className="ps-1_5">
              {isSingleYear ? (
                <span className="text-white size-14">Awarded {years[0]}</span>
              ) : (
                <button className="text-white size-14 cursor-pointer p-0" onClick={toggleOpen} aria-expanded={isOpen}>
                  <span>Awarded {getYearsRange(years)}</span>
                  <i
                    className={classNames('ms-0_5 size-12', { 'icon-arrow-up4': isOpen, 'icon-arrow-down4': !isOpen })}
                    aria-hidden
                  />
                </button>
              )}
            </div>
          </div>
          <Collapse id="expanded-years" isOpen={isOpen} transition="0.25s ease-in-out">
            <div className="expanded-years mt-1 text-white size-14">All awarded years: {years.join(', ')}</div>
          </Collapse>
        </div>
      </div>
    </div>
  );
}

DealerFiveStarAwards.propTypes = {
  years: PropTypes.arrayOf(PropTypes.number).isRequired,
};
